import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { merge } from 'lodash';
import { defaultTransfer } from '@utils/recordHelpers';

import { PolarisFormProvider } from '@container';

import { TransferForm } from '@presentational';
import { ResourceList, DisplayText, Button } from '@shopify/polaris';

import ImportModal from 'components/presentational/shared/ImportFileModal';
import axiosRails from '@utils/axios';
import { render } from 'react-dom';

const propTypes = {
  transfer: PropTypes.object.isRequired,
  submitURL: PropTypes.string.isRequired,
  importURL: PropTypes.string.isRequired,
  polarisForm: PropTypes.object.isRequired, // Polaris formik provider props.
  pageProps: PropTypes.shape({
    breadcrumbs: PropTypes.array.isRequired,
  }),
  sellerUserId: PropTypes.number, // To query over products from admin access scoping to transfer seller
};

const defaultProps = {
  update: false,
}

class TransferFormContainer extends Component {
  constructor(props) {
    super(props);
    this.state= {
      importOpen: false,
      importLoading: false,
      importFile: null,
      importErrors: [],
    }
  }

  onSelection = (_bla, variantRecord) => {

  }

  submitUpload = async () => {
    await this.setState({ importLoading: true })
    try {
      let formData = new FormData();
      formData.append("import_file", this.state.importFile);
      let response = await axiosRails.post(this.props.importURL, formData);
      const data = response.data;
      console.log(data);
      // setValues
      // setErrors
      if(data.success){
        const parsedRecords = data.records.map( (variant, index) => ({
          variant: variant,
          quantity: variant.virtual_quantity,
          unit_cost: variant.virtual_price,
          variant_id: variant.id,
        }))
        this.props.polarisForm.setFieldValue("products_transfers_attributes", parsedRecords);
        this.setState({ importOpen: false, importFile: null, importErrors: [], importLoading: false })
        this.props.polarisForm.pushToast("Importación exitosa.")
      } 
      else{
        this.setState({
          importLoading: false,
          importErrors: data.errors
        })
      }
    } catch (error) {
      console.log("Error", error)
      this.setState({ importLoading: false })
    }
  }

  openImportModal = () => this.setState({ importOpen: true })
  closeImportModal = () => this.setState({ importOpen: false })

  handleImportDrop = (_dropFiles, acceptedFiles, _rejectedFiles) => {
    this.setState({
      importFile: acceptedFiles[0],
      importErrors: [],
    });
  }

  handleImportDelete = () => this.setState({ importFile: null })

  render() {
    let { queryURL, polarisForm, update } = this.props;
    // console.log("pp",this.props);
    return (
      <div>
        <div className="flex justifyBetween alignItemsCenter mb20">
          <DisplayText size="large">
            { I18n.t("activerecord.models.transfer.one") }
          </DisplayText>

          <div>
            <Button outline monochrome onClick={ this.openImportModal }>
              Importar archivo
            </Button>
          </div>
        </div>

        <TransferForm
          queryURL={ queryURL }
          sellerUserId={ this.props.sellerUserId }
          isSeller
          onSelection={ polarisForm.pushNewValue }
          renderItem={ this.renderItem }
          loading={ polarisForm.status.submitLoading }
          openModal={ this.openImportModal }
          update={ update }
          {...polarisForm} />
        <ImportModal
          open={ this.state.importOpen }
          loading={ this.state.importLoading }
          importFile={ this.state.importFile }
          errors={ this.state.importErrors }

          dropZoneLabel="Archivo xlsx o csv. La primera fila debe contener las cabeceras 'SKU', 'Costo' y 'Cantidad'"
          
          onDrop={ this.handleImportDrop }
          onDeleteFile={ this.handleImportDelete }
          onUpload={ this.submitUpload }
          onCancel={ this.closeImportModal }
          />
      </div>
    );
  }
}


TransferFormContainer.propTypes = propTypes;
TransferFormContainer.defaultProps = defaultProps;

const WrappedTransferFormContainer = (props) => {
  let { submitURL, update } = props;
  const defaultValues = update ? { ...props.transfer, products_transfers_attributes: props.transfer.products_transfers } : merge(props.transfer, defaultTransfer);
  return (
    <PolarisFormProvider
      containerClass="no-margin-header"
      defaultValues={ defaultValues }
      submitURL={ submitURL }
      submitMethod={ update ? "PATCH" : "POST" }
      paramsName="transfer"
      pageProps={ props.pageProps }
    >
      { (renderProps) => 
        <TransferFormContainer
          {...props}
          polarisForm={renderProps}
        />
      }
    </PolarisFormProvider>
  );
}


export default WrappedTransferFormContainer;
